module.exports = __webpack_public_path__ + "img/sleeve_cap_rise.a2e661dd.png";